export default __webpack_public_path__ + "static/media/3mug.60371a48.jpg";